import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { PLATFORM_ID, inject } from '@angular/core';
import { BrowserStorageService } from '@core/services/browser-storage/browser-storage.service';
export const authorizationInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  const browserStorageService = inject(BrowserStorageService);
  const skipIntercept = req.headers.has('skip');
  if (skipIntercept) {
    req = req.clone({
      headers: req.headers.delete('skip'),
    });
  } else {
    if (isBrowser) {
      const accessToken = browserStorageService.get('accessToken');
      if (accessToken) {
        req = req.clone({
          setHeaders: { Authorization: `Bearer ${accessToken}` },
        });
      } else {
        //navigate to login
      }
    }
  }
  return next(req);
};
